import React, {
  useEffect,
  useState,
  useContext,
  forwardRef,
  createRef,
  useLayoutEffect,
} from "react";
import app from "../../services/base.js";
import Message from "../../components/message/Message";
import SystemMessage from "../../components/system-message/SystemMessage.jsx";
import "./MessageList.scss";
import CloseIcon from "@material-ui/icons/Close";
import CheckIcon from "@material-ui/icons/Check";
import { AuthContext } from "../../services/Authentication.js";
import arrowBottom from "../../assets/arrowBottom.png";
import IconButton from "@material-ui/core/IconButton";
import DynamicInput from "../../components/DynamicInput/DynamicInput.js";
import { withStyles } from "@material-ui/core/styles";
import Close from "@material-ui/icons/Close";
import {
  maxTextLength,
  formatedTextReplaceMention,
} from "../../utils/formatters.js";
import AlertDialog from "../../components/modal/index";
import { Image, Videocam, InsertDriveFile } from "@material-ui/icons";

const styles = () => ({
  colorDefault: {
    backgroundColor: "#51A6FF",
    width: "5rem",
    height: "5rem",
  },
  title: {
    marginLeft: 10,
    color: "#303030",
    fontSize: "1.6rem",
  },
  chatTitle: {
    display: "flex",
    alignItems: "center",
    marginTop: "2rem",
    cursor: "pointer",
  },
  fixedMessage: {
    background: "#fff",
    width: "61%",
    marginRight: 3,
    position: "absolute",
    display: "flex",
    top: 110,
    flexDirection: "column",
    zIndex: 1000,
  },
  header: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  legend: {
    color: "#404040",
    fontSize: "1.3rem",
    fontWeight: 400,
    wordWrap: "break-word",
  },
  divMessage: {
    cursor: "pointer",
  },
  labelMessage: {
    color: "#404040",
    border: "1px #fff solid",
    backgroundColor: "#F4F4F4",
    padding: 11,
    fontSize: 14,
    borderLeftColor: "#071FC1",
    borderLeftWidth: 6,
    borderEndStartRadius: 6,
    borderStartStartRadius: 6,
  },
});

const MessageList = ({
  displayReplyView,
  targetToReply,
  conversationId,
  users,
  moderator,
  eventId,
  chatType,
  setSelectedConversation,
  sendMessage,
  selectedConversation,
  showBio,
  classes,
}) => {
  const { currentUser } = useContext(AuthContext);
  const [messages, setMessages] = useState([]);
  const [isManager, setAdmCommunity] = useState(false);
  const [editMessageState, setEditMessageState] = useState(false);
  const [editMessageText, setEditMessageText] = useState({});
  const [suggestions, setSuggestions] = useState([]);
  const [showPinnedMessage, setShowPinnedMessage] = useState(false);
  const [pinnedMessage, setPinnedMessage] = useState({});
  const [open, setOpen] = useState(false);
  const [parentDimension, setParentDimension] = useState(undefined);

  useEffect(() => {
    setMessages([]);
    const cancelListener = app
      .firestore()
      .collection("connections")
      .doc(conversationId)
      .collection("chat")
      .orderBy("createdAt", "desc")
      .onSnapshot(async (querySnapshot) => {
        const Batch = app.firestore().batch();
        let _msgs = [];
        querySnapshot.docs.forEach((doc) => {
          _msgs.push(formattedMessage(doc.data()));
          if (
            !doc.data().userSeen ||
            !doc.data().userSeen.includes(currentUser.id)
          ) {
            if (
              !doc.data().system &&
              doc.data().users &&
              doc.data().users.includes(currentUser.id)
            ) {
              Batch.update(doc.ref, {
                userSeen: [...(doc.data().userSeen || []), currentUser.id],
              });
            }
          }
        });
        setMessages(_msgs);
        await Batch.commit();
      });
    return () => cancelListener();
  }, [conversationId, currentUser.id]);

  useEffect(() => {
    if (
      document.getElementById("chat-message-list") &&
      document.getElementById("pinnedMessage")
    ) {
      setParentDimension({
        width: document.getElementById("chat-message-list").clientWidth - 40,
        top: document.getElementById("chat-title").clientHeight + 10,
      });
      window.addEventListener("resize", (ev) => {
        setParentDimension({
          width: document.getElementById("chat-message-list").clientWidth - 40,
          top: document.getElementById("chat-title").clientHeight + 10,
        });
      });
    }
    return () => {
      window.removeEventListener("resize", (ev) => {
        setParentDimension({
          width: document.getElementById("chat-message-list").clientWidth - 40,
          top: document.getElementById("chat-title").clientHeight + 10,
        });
      });
    };
  }, [
    document.getElementById("chat-title"),
    document.getElementById("chat-message-list"),
    document.getElementById("pinnedMessage"),
    showBio,
  ]);

  useEffect(() => {
    if (chatType !== "GroupChat") {
      setSuggestions([]);
      setPinnedMessage({});
      setShowPinnedMessage(false);
    } else {
      setPinnedMessage({});
      setShowPinnedMessage(false);
      let pinned = selectedConversation.groupInfo.pinnedMessage;
      if (
        pinned &&
        Object.keys(pinned).length > 0 &&
        Object.getPrototypeOf(pinned) === Object.prototype
      ) {
        setPinnedMessage(pinned);
        setShowPinnedMessage(true);
      }
      getAttenders();
    }
    return () => {};
  }, [conversationId]);

  useEffect(() => {
    const cancelListener = app
      .firestore()
      .collection("events")
      .doc(eventId)
      .onSnapshot(async (querySnapshot) => {
        if (!querySnapshot || !querySnapshot.data()) {
          setAdmCommunity(false);
          return;
        }
        const isManager =
          querySnapshot.data().manager &&
          querySnapshot
            .data()
            .manager.find(
              (manager) =>
                manager.userId === currentUser.id && manager.level >= 2
            );
        setAdmCommunity(isManager && Object.keys(isManager).length > 0);
      });
    return () => cancelListener();
  }, [eventId, currentUser.id]);

  async function getAttenders() {
    const event = await app.firestore().collection("events").doc(eventId).get();

    let suggestions = event
      .data()
      .attenders.filter(
        (attender) =>
          attender.id !== currentUser.id && users.includes(attender.id)
      )
      .map((attender) => {
        return {
          ...attender,
          display: `${attender.firstName || ""} ${attender.lastName || ""}`,
        };
      });

    suggestions = [
      {
        id: "grupo",
        name: "grupo",
        firstName: "grupo",
        lastName: "",
        everyone: true,
        display: "grupo",
      },
      ...suggestions,
    ];
    suggestions.sort((a, b) => a.id - b.id);
    setSuggestions(suggestions);
  }
  function formattedMessage(_msg) {
    if (typeof _msg.createdAt !== "string" && _msg.createdAt.seconds) {
      var options = {
        hour: "2-digit",
        minute: "2-digit",
        year: "numeric",
        month: "2-digit",
        day: "numeric",
      };

      _msg.createdAt = new Date(
        _msg.createdAt.seconds * 1000
      ).toLocaleDateString("pt-br", options);
    }
    if (!_msg.system) {
      _msg.isMyMessage = _msg.user._id === currentUser.id;
    }
    return _msg;
  }
  async function removePinnedMessage() {
    setShowPinnedMessage(false);
    const getMessageById = await await app
      .firestore()
      .collection("connections")
      .doc(selectedConversation.id)
      .get();
    getMessageById.ref.set(
      { groupInfo: { ...getMessageById.data().groupInfo, pinnedMessage: {} } },
      { merge: true }
    );
    setPinnedMessage({});
    setOpen(false);
  }
  function renderAttachment(attachment) {
    if (attachment.type.includes("image")) {
      return (
        <div className="render-attachment">
          <Image /> <span> Imagem</span>
        </div>
      );
    } else if (attachment.type.includes("video")) {
      return (
        <div className="render-attachment">
          <Videocam /> <span> Vídeo</span>
        </div>
      );
    } else {
      return (
        <div className="render-attachment">
          <InsertDriveFile /> <span> Documento</span>
        </div>
      );
    }
  }
  function renderPinnedMessage() {
    if (!showPinnedMessage) return false;

    return (
      <div
        id="pinnedMessage"
        className={classes.fixedMessage}
        style={{
          width: parentDimension
            ? parentDimension.width
            : document.getElementById("chat-message-list").clientWidth - 40,
          top: parentDimension
            ? parentDimension.top
            : document.getElementById("chat-title").clientHeight + 10,
        }}
      >
        <div className={classes.header}>
          <span style={{ color: "#303030", fontSize: 14 }}>
            Mensagem fixada
          </span>
          <div
            style={{ float: "right" }}
            onClick={() => {
              setOpen(true);
            }}
          >
            <span>
              <Close
                style={{
                  fontSize: 25,
                  color: "#0256AD",
                  cursor: "pointer",
                }}
              />
            </span>
          </div>
        </div>
        <div
          className={classes.divMessage}
          onClick={() => {
            handleClick(pinnedMessage._id);
          }}
        >
          <div className={classes.labelMessage}>
            {pinnedMessage.attachment &&
              renderAttachment(pinnedMessage.attachment)}
            <span className={classes.legend}>
              {pinnedMessage.text
                ? maxTextLength(
                    formatedTextReplaceMention(
                      pinnedMessage.text.replace(/(\r\n|\n|\r)/gm, " ")
                    ),
                    225
                  )
                : ""}
            </span>
          </div>
        </div>
      </div>
    );
  }

  const handleScroll = (e) => {
    const { scrollTop } = e.target;
    if (scrollTop && scrollTop * -1 > 300) {
      document.getElementsByClassName("buttonChat")[0].style.display = "flex";
    } else {
      document.getElementsByClassName("buttonChat")[0].style.display = "none";
    }
  };
  const goBackInit = () => {
    document.getElementById("chat-message-list").scrollTop = 0;
  };

  const refs = messages.reduce((acc, value) => {
    if (value.isReply) {
      acc[value.reply._id] = createRef();
    } else {
      acc[value._id] = createRef();
    }
    return acc;
  }, {});

  function handleClick(id) {
    if (refs[id] && refs[id].current) {
      refs[id].current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }

  async function removeMessage(message) {
    const threadChatRef = app
      .firestore()
      .collection("connections")
      .doc(conversationId);
    const getMessabeById = await threadChatRef
      .collection("chat")
      .where("_id", "==", message._id)
      .limit(1)
      .get();
    const threadChat = await threadChatRef.get();
    if (threadChat.data().lastMessage._id === message._id) {
      threadChat.ref.set(
        {
          lastMessage: {
            ...threadChat.data().lastMessage,
            system: true,
            tag: "delete",
          },
        },
        { merge: true }
      );
    }
    if (message.attachment) {
      let attachment = threadChat
        .data()
        .lastAttachments.find((elem) => elem._id === message._id);
      if (attachment) {
        threadChat.ref.set(
          {
            lastAttachments: [
              ...threadChat
                .data()
                .lastAttachments.filter(
                  (elem) => !elem._id || elem._id !== message._id
                ),
            ],
          },
          { merge: true }
        );
      }
    }
    getMessabeById.forEach((message) => {
      message.ref.set(
        {
          text: "",
          tag: "delete",
          selectUsers: [],
          system: true,
        },
        { merge: true }
      );
    });
  }

  async function pinMessage(message) {
    setShowPinnedMessage(true);
    const getMessageById = await app
      .firestore()
      .collection("connections")
      .doc(conversationId)
      .get();

    getMessageById.ref.set(
      {
        groupInfo: {
          ...getMessageById.data().groupInfo,
          pinnedMessage: message,
        },
      },
      { merge: true }
    );
    setPinnedMessage(message);
  }
  async function editMessage(message) {
    setEditMessageState(true);
    setEditMessageText(message);
  }

  async function setEditMessage() {
    const threadChatRef = app
      .firestore()
      .collection("connections")
      .doc(conversationId);
    const getMessageById = await threadChatRef
      .collection("chat")
      .where("_id", "==", editMessageText._id)
      .limit(1)
      .get();

    const threadChat = await threadChatRef.get();
    if (threadChat.data().lastMessage._id === editMessageText._id) {
      threadChat.ref.set(
        {
          lastMessage: {
            ...threadChat.data().lastMessage,
            text: editMessageText.text,
          },
        },
        { merge: true }
      );
    }
    getMessageById.forEach((message) => {
      message.ref.set(
        {
          text: editMessageText ? editMessageText.text.trim() : "",
          edited: true,
        },
        { merge: true }
      );
    });
    setEditMessageState(false);
    setEditMessageText({});
  }

  return (
    <>
      <div
        id="chat-message-list"
        style={{
          marginTop:
            showPinnedMessage && document.getElementById("chat-message-list")
              ? "9.4%"
              : 0,
        }}
        onScroll={handleScroll}
      >
        <div>
          {showPinnedMessage && document.getElementById("chat-message-list")
            ? renderPinnedMessage()
            : null}
          <AlertDialog
            textConfirmation={"Desfixar"}
            open={open}
            actionCancel={() => setOpen(false)}
            actionConfirmation={removePinnedMessage}
            title={"Desfixar mensagem do grupo?"}
            legend={"Ao confirmar a mensagem será removida do topo."}
            buttonConfirmation={true}
          />
        </div>

        {messages.map((message) => {
          if (message.system) {
            return (
              <SystemMessage
                key={message._id}
                message={message}
                currentUserId={currentUser.id}
                sendMessage={sendMessage}
              />
            );
          }
          return (
            <Message
              ref={
                message.isReply ? refs[message.reply._id] : refs[message._id]
              }
              key={message.isReply ? message.reply._id : message._id}
              handleClick={() =>
                message.isReply
                  ? handleClick(message.reply._id)
                  : handleClick(message._id)
              }
              moderator={moderator}
              isMyMessage={message.isMyMessage}
              message={message}
              displayReplyView={displayReplyView}
              targetToReply={targetToReply}
              currentUserId={currentUser.id}
              isManager={isManager}
              editMessage={editMessage}
              removeMessage={removeMessage}
              pinMessage={pinMessage}
              chatType={chatType}
              currentUser={currentUser}
              setSelectedConversation={setSelectedConversation}
              eventId={eventId}
              sendMessage={sendMessage}
            />
          );
        })}
        <div className="buttonChat" onClick={() => goBackInit()}>
          <IconButton color="primary">
            <img src={arrowBottom} height={24.5} width={24.5} alt="Descer" />
          </IconButton>
        </div>
      </div>
      {editMessageState && (
        <div className="div-edit">
          <DynamicInput
            setTextMessage={(value) => {
              setEditMessageText({ ...editMessageText, text: value });
            }}
            textMessage={editMessageText.text}
            MentionsInputProps={{
              placeholder: "Editar mensagem",
              className: "mentions",
              multiLine: true,
              markup: "@[display](id)",
              allowSuggestionsAboveCursor: true,
              style: {
                maxHeight: "75px",
                minHeight: "38px",
                minWidth: "300px",
                resize: "none",
                padding: "9px",
                boxSizing: "border-box",
                fontSize: "15px",
                fontFamily: "Open Sans",
              },
              rows: 1,
              autoFocus: true,
            }}
            MentionsProps={{
              trigger: "@",
              data: suggestions,
              displayTransform: (id, display) => `@${display}`,
              appendSpaceOnAdd: true,
              style: { backgroundColor: "#51A6FF" },
            }}
          />
          <div
            disabled={false}
            onClick={() => {
              setEditMessage();
            }}
          >
            <CheckIcon className={"icon-ui icon-Check"} />
          </div>
          <div
            disabled={false}
            onClick={() => {
              setEditMessageState(false);
            }}
          >
            <CloseIcon className={"icon-ui icon-close"} />
          </div>
        </div>
      )}
    </>
  );
};

export default withStyles(styles)(MessageList);
